import { useQuery } from '@tanstack/react-query';
import { dbClient, normalizeRpcResponse } from '@/services/db-client';
import { useAuth } from '@/hooks/useAuth';

export interface MerchSummary {
    productTotal: number;
    productActive: number;
    variantActive: number;
    unlimitedVariants: number;
    unitsOnHand: number;
    salesCents: number;
    orderCount: number;
}

export function useMerchSummary() {
    const { user } = useAuth();
    return useQuery<MerchSummary>({
        queryKey: ['admin', 'store-merch-summary'],
        enabled: Boolean(user?.id),
        queryFn: async () => {
            const { data, error } = await dbClient.rpc('admin_get_merch_summary', {
                p_admin_user_id: user!.id,
            });
            if (error) throw new Error(error.message);
            const row = normalizeRpcResponse(data)[0] ?? {};
            const summary = row as Partial<MerchSummary>;
            return {
                productTotal: Number(summary.productTotal ?? 0),
                productActive: Number(summary.productActive ?? 0),
                variantActive: Number(summary.variantActive ?? 0),
                unlimitedVariants: Number(summary.unlimitedVariants ?? 0),
                unitsOnHand: Number(summary.unitsOnHand ?? 0),
                salesCents: Number(summary.salesCents ?? 0),
                orderCount: Number(summary.orderCount ?? 0),
            };
        },
        staleTime: 30_000,
    });
}
